import { createEventBus } from '@/event-bus';

export const codeNodeEditorEventBus = createEventBus();
